import { createStore, combineReducers, applyMiddleware } from 'redux'
import thunk from 'redux-thunk'
import { composeWithDevTools } from 'redux-devtools-extension'

import {
    userLoginReducer,
    userRegisterReducer,
    userDetailsReducer,
    userUpdateProfileReducer,
} from './reducers/userReducers'

import {
    placeListReducer,
    placeDetailsReducer,
    placeCreateReducer,
    placeUpdateReducer,
    placeDeleteReducer,
} from './reducers/placeReducers'

import {
    categoryListReducer,
    categoryCreateReducer,
    categoryDeleteReducer,
} from './reducers/categoryReducers'

import { mapReducer } from './reducers/mapReducers'

const reducer = combineReducers({
    userLogin: userLoginReducer,
    userRegister: userRegisterReducer,
    userDetails: userDetailsReducer,
    userUpdateProfile: userUpdateProfileReducer,

    placeList: placeListReducer,
    placeDetails: placeDetailsReducer,
    placeCreate: placeCreateReducer,
    placeUpdate: placeUpdateReducer,
    placeDelete: placeDeleteReducer,

    categoryList: categoryListReducer,
    categoryCreate: categoryCreateReducer,
    categoryDelete: categoryDeleteReducer,

    map: mapReducer,
})

const userInfoFromStorage = localStorage.getItem('userInfo') ?
    JSON.parse(localStorage.getItem('userInfo')) : null

const initialState = {
    userLogin: { userInfo: userInfoFromStorage },
}

const middleware = [thunk]

const store = createStore(reducer, initialState,
    composeWithDevTools(applyMiddleware(...middleware)))

export default store
